var soitworker;

function startSoitWorker() {
    if (typeof (Worker) !== "undefined") {
        try {
            if (typeof (soitworker) === "undefined") {
                soitworker = new Worker("https://www.dell.com/support/staticcdn/worker/js/1.1/worker.min.js");
            }
            window.WebWorkerCompleted = false;
            soitworker.postMessage({ "args": [JSON.stringify(Dell)] });
            soitworker.onmessage = function (event) {
                window.searchAutosuggestProductDetails = event.data;
                window.WebWorkerCompleted = true;
                if (typeof window.autoSuggestWWComplete === "function") {
                    var callbackfunc = window.autoSuggestWWComplete;
                    callbackfunc.call(this);
                };
                stopSoitWorker();
            };
        } catch (e) {
            if (typeof window.autoSuggestLoadError === "function") {
                var callbackfunc = window.autoSuggestLoadError;
                callbackfunc.call(this, e);
            }
        }
    } else {
        console.log("No Web Worker");
    }
}

function stopSoitWorker() {
    soitworker.terminate();
    soitworker = undefined;
}

function callWebWorker() {
    if (typeof (Dell) !== 'undefined' &&
        typeof (Dell.OnlineUtils) !== 'undefined' &&
        typeof (Dell.OnlineUtils.AppSettings) !== 'undefined' &&
        typeof (Dell.OnlineUtils.AppSettings.Unified) !== 'undefined' &&
        typeof (Dell.OnlineUtils.AppSettings.Unified.UnifiedAutosuggestJsUrl) !== 'undefined' &&
        typeof (window.searchAutosuggestProductDetails) === 'undefined') {
        startSoitWorker();
    }
}

if (typeof (callWebWorker_event) === 'function') {
    callWebWorker_event();
}